<template>
    <BContainer class="container-pages"  v-if="advertisement">
        <BRow>
         <BCol class="mt-2 mb-3 font-size-18">
          <p class="info-label">Opis oglasa</p>
             <div class="ps-2 content-html "  
                  >
                  <div class="ql-editor p-0" v-html="advertisement?.description">

                  </div>
           </div>
         </BCol>   
      </BRow>
    </BContainer>
  </template>
  
  <script setup>
import { BCol, BContainer, BRow } from 'bootstrap-vue-next';


  
  const props = defineProps({
      advertisement:{
          required: true,
          type : Object 
      },
       
  })
   
  </script>
  
  <style>
  
  </style>
